<template>
  <mdb-container id="body-background" fluid style="background-color: #f5f5f5">
    <mdb-container class="py-5">
      <mdb-row class="mb-5">
        <mdb-col>
          <mdb-card>
            <mdb-card-body>
              <!-- <img :src="require('@/assets/logo.jpg')" class="img-fluid"/> -->
              <h2>Pendaftaran Rakan Niaga Lapar</h2>
              <h5 class="text-justify">Sila lengkapkan maklumat di bawah untuk meneruskan pendaftaran. Kawasan liputan terkini kami adalah : Shah Alam, Johor Bahru , Wangsa Maju, Lembah Pantai.</h5>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
      <mdb-row class="mb-5">
        <mdb-col>
          <mdb-card>
            <mdb-card-body>
              <h5>Untuk Makluman Anda</h5>
              <p class="text-justify">Permohonan anda akan diproses dalam masa 14 hari.</p>
              <p class="text-justify">Pastikan maklumat yang diperlukan untuk pendaftaran dimuat naik dan diisi dengan maklumat yang lengkap.</p>
              <p class="text-justify">Muatnaik fail digalakkan dalam format pdf.</p>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
      <mdb-row class="mb-5">
        <mdb-col>
          <mdb-card>
            <mdb-card-body>
              <mdb-row>
                <mdb-col md="6" col="12" offsetMd="3">
                  <img :src="require('@/assets/keluarga_lapar.jpeg')" class="img-fluid" />
                </mdb-col>
              </mdb-row>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
      <mdb-row class="mb-3">
        <mdb-col>
          <mdb-card>
            <mdb-card-body>
              <h5 class="h5-responsive">Adakah Anda Mnggunakan Perkhidmatan Berikut <small>(Tidak Perlu Isi Jika Tiada)</small></h5>
              <mdb-row>
                <mdb-col col="12">
                  <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" v-model.trim="merchant.services" value="Food Panda" class="custom-control-input" id="checkbox-1">
                    <label class="custom-control-label" for="checkbox-1">Food Panda</label>
                  </div>
                  <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" v-model.trim="merchant.services" value="Grab Food" class="custom-control-input" id="checkbox-2">
                    <label class="custom-control-label" for="checkbox-2">Grab Food</label>
                  </div>
                  <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" v-model.trim="merchant.services" value="Hungry" class="custom-control-input" id="checkbox-3">
                    <label class="custom-control-label" for="checkbox-3">Hungry</label>
                  </div>
                  <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" v-model.trim="merchant.services" value="Delivery Eat" class="custom-control-input" id="checkbox-4">
                    <label class="custom-control-label" for="checkbox-4">Delivery Eat</label>
                  </div>
                  <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" v-model.trim="merchant.services" value="Other" class="custom-control-input" id="checkbox-5">
                    <label class="custom-control-label" for="checkbox-5">Lain-lain</label>
                  </div>
                </mdb-col>
              </mdb-row>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
      <mdb-row class="mb-3" id="form-start">
        <mdb-col>
            <mdb-card>
                <mdb-card-body>
                    <h4 class="h4-responsive" :style="{color: getColor('APP_1')}">Maklumat Restoran Atau Jenama</h4>
                    <mdb-row>
                        <mdb-col md="6">
                            <mdb-input :customValidation="validated" :isValid="!validation.name" :invalidFeedback="validation.name" label="Nama Restoran Atau Jenama *" v-model.trim="merchant.name" size="sm" />
                            <mdb-input :customValidation="validated" :isValid="!validation.contact_number" :invalidFeedback="validation.contact_number" label="No. Telefon *" v-model.trim="merchant.contact_number" size="sm" />
                            <mdb-input :customValidation="validated" :isValid="!validation.company_registration_name" :invalidFeedback="validation.company_registration_name" v-model.trim="merchant.company_registration_name" label="Nama Pendaftaran SSM atau Nama Pemilik Perniagaan *" size="sm" />
                            <mdb-input :customValidation="validated" :isValid="!validation.company_registration_id" :invalidFeedback="validation.company_registration_id" v-model.trim="merchant.company_registration_id" label="No SSM atau IC Permilik Perniagaan *" size="sm" />
                        </mdb-col>
                        <mdb-col md="6">
                            <mdb-input :customValidation="validated" :isValid="!validation.email" :invalidFeedback="validation.email" label="Emel *" v-model.trim="merchant.email" size="sm" />
                            <mdb-input :customValidation="validated" :isValid="!validation.address" :invalidFeedback="validation.address" label="Alamat Perniagaan *" v-model.trim="merchant.address" size="sm" />
                            <mdb-input label="Website Perniagaan atau Facebook URL" v-model.trim="merchant.website" size="sm" />
                            <mdb-input label="Cukai No." v-model.trim="merchant.tax_id" size="sm" />
                        </mdb-col>
                    </mdb-row>
                    <mdb-row>
                      <mdb-col col="12">
                        <mdb-input type="textarea" label="Waktu Beroperasi" v-model.trim="merchant.alt_remarks" :rows="7"/>
                      </mdb-col>
                    </mdb-row>
                </mdb-card-body>
            </mdb-card>
        </mdb-col>
    </mdb-row>
    <mdb-row class="mb-3">
        <mdb-col>
            <mdb-card>
                <mdb-card-body>
                    <h4 class="h4-responsive" :style="{color: getColor('APP_1')}">Maklumat Banking</h4>
                    <mdb-row>
                        <mdb-col md="6">
                          <mdb-input :customValidation="validated" :isValid="!validation.bank_account_name" :invalidFeedback="validation.bank_account_name" v-model.trim="merchant.bank_account_name" label="Nama Pemegang Akaun *" size="sm" />
                          <mdb-input :customValidation="validated" :isValid="!validation.bank_account_number" :invalidFeedback="validation.bank_account_number" v-model.trim="merchant.bank_account_number" label="No Akaun Bank *" size="sm" />
                        </mdb-col>
                        <mdb-col md="6">
                          <label style="font-size: 0.75rem; margin-bottom: 0px; color: #757575">Bank *</label>
                          <select :customValidation="validated" :isValid="!validation.bank_name" :invalidFeedback="validation.bank_name" v-model.trim="merchant.bank_name" class="custom-select custom-select">
                            <option value="08-AmBank Berhad">08-AmBank Berhad</option>
                            <option value="12-Alliance Bank Berhad">12-Alliance Bank Berhad</option>
                            <option value="53-Al-Rajhi Banking and Investment Corporation (Malaysia) Berhad">53-Al-Rajhi Banking and Investment Corporation (Malaysia) Berhad</option>
                            <option value="32-Affin Bank Berhad">32-Affin Bank Berhad</option>
                            <option value="49-Agro Bank">49-Agro Bank</option>
                            <option value="42-Bank of China (Malaysia) Berhad">42-Bank of China (Malaysia) Berhad</option>
                            <option value="41-Bank Muamalat Malaysia Berhad">41-Bank Muamalat Malaysia Berhad</option>
                            <option value="45-Bank Islam Malaysia Berhad">45-Bank Islam Malaysia Berhad</option>
                            <option value="02-Bank Rakyat Berhad">02-Bank Rakyat Berhad</option>
                            <option value="10-Bank Simpanan Nasional Berhad">10-Bank Simpanan Nasional Berhad</option>
                            <option value="07-Bank of America">07-Bank of America</option>
                            <option value="52-Bank of Tokyo-Mitsubishi UFJ (Malaysia) Berhad">52-Bank of Tokyo-Mitsubishi UFJ (Malaysia) Berhad</option>
                            <option value="60-BNP Paribas (M) Bhd / BNP Paribas (Islamic)">60-BNP Paribas (M) Bhd / BNP Paribas (Islamic)</option>
                            <option value="35-CIMB Bank Berhad">35-CIMB Bank Berhad</option>
                            <option value="17-Citibank">17-Citibank</option>
                            <option value="19-Deutsche Bank (M) Bhd">19-Deutsche Bank (M) Bhd</option>
                            <option value="24-Hong Leong Bank Berhad/ Hong Leong Finance">24-Hong Leong Bank Berhad/ Hong Leong Finance</option>
                            <option value="22-HSBC Bank Berhad">22-HSBC Bank Berhad</option>
                            <option value="59-Indust & Comm Bank of China (M) Berhad">59-Indust & Comm Bank of China (M) Berhad</option>
                            <option value="48-JP Morgan Chase">48-JP Morgan Chase</option>
                            <option value="47-Kuwait Finance House">47-Kuwait Finance House</option>
                            <option value="27-Malayan Banking Berhad">27-Malayan Banking Berhad</option>
                            <option value="73-Mizuho Bank (M) Berhad">73-Mizuho Bank (M) Berhad</option>
                            <option value="29-OCBC Bank Berhad">29-OCBC Bank Berhad</option>
                            <option value="33-Public Bank Berhad/ Public Finance Berhad">33-Public Bank Berhad/ Public Finance Berhad</option>
                            <option value="18-RHB Bank Berhad">18-RHB Bank Berhad</option>
                            <option value="14-Standard Chartered Bank Berhad">14-Standard Chartered Bank Berhad</option>
                            <option value="51-Sumitomo Mitsui Banking Corporation (M) Bhd ">51-Sumitomo Mitsui Banking Corporation (M) Bhd </option>
                            <option value="46-The Royal Bank of Scotland Bhd">46-The Royal Bank of Scotland Bhd</option>
                            <option value="26-United Overseas Bank (M) Bhd">26-United Overseas Bank (M) Bhd</option>
                          </select>
                          <p class="text-danger small">{{validation.bank_name}}</p>
                        </mdb-col>
                    </mdb-row>
                </mdb-card-body>
            </mdb-card>
        </mdb-col>
    </mdb-row>
    <mdb-row class="mb-3">
        <mdb-col>
            <mdb-card>
                <mdb-card-body>
                  <h4 class="h4-responsive" :style="{color: getColor('APP_1')}">Contact Information</h4>
                  <h5 class="h5-responsive">Owner Detail</h5>
                  <mdb-row>
                    <mdb-col md="6">
                      <mdb-input v-model.trim="merchant.owner_name" label="Owner Name" size="sm" />
                      <mdb-input v-model.trim="merchant.owner_ic" label="Owner IC" size="sm" />
                    </mdb-col>
                    <mdb-col md="6">
                      <mdb-input v-model.trim="merchant.owner_mobile" label="Owner Mobile" size="sm" />
                      <mdb-input v-model.trim="merchant.owner_email" label="Owner Email" size="sm" />
                    </mdb-col>
                  </mdb-row>
                  <h5 class="h5-responsive">Person in Charge Detail <span class="text-link" @click="copyOwnerToPIC()">Sama seperti owner</span></h5>
                  <mdb-row>
                    <mdb-col md="6">
                      <mdb-input v-model.trim="merchant.pic_name" label="PIC Name" size="sm" />
                      <mdb-input v-model.trim="merchant.pic_ic" label="PIC IC" size="sm" />
                    </mdb-col>
                    <mdb-col md="6">
                      <mdb-input :customValidation="validated" :isValid="!validation.pic_mobile" :invalidFeedback="validation.pic_mobile" v-model.trim="merchant.pic_mobile" label="PIC Mobile *" size="sm" />
                      <mdb-input v-model.trim="merchant.pic_email" label="PIC Email" size="sm" />
                    </mdb-col>
                  </mdb-row>
                  <h5 class="h5-responsive">Finance Detail <span class="text-link" @click="copyOwnerToFinance()">Sama seperti owner</span></h5>
                  <mdb-row>
                    <mdb-col md="6">
                      <mdb-input v-model.trim="merchant.financial_name" label="Finance Name" size="sm" />
                      <mdb-input v-model.trim="merchant.financial_ic" label="Finance IC" size="sm" />
                    </mdb-col>
                    <mdb-col md="6">
                      <mdb-input v-model.trim="merchant.financial_mobile" label="Finance Mobile" size="sm" />
                      <mdb-input :customValidation="validated" :isValid="!validation.financial_email" :invalidFeedback="validation.financial_email" v-model.trim="merchant.financial_email" label="Finance Email *" size="sm" />
                    </mdb-col>
                  </mdb-row>
                </mdb-card-body>
            </mdb-card>
        </mdb-col>
      </mdb-row>
      <mdb-row class="mb-3">
        <mdb-col>
            <mdb-card>
                <mdb-card-body>
                  <h4 class="h4-responsive" :style="{color: getColor('APP_1')}">File Upload</h4>
                  <mdb-row>
                    <mdb-col md="3">
                      <mdb-view :src="merchant.avatar?getUrl(merchant.avatar):require('@/assets/logo.jpg')">
                        <a @click="openUrl(getUrl(merchant.avatar))">
                          <mdb-mask overlay="white-slight"></mdb-mask>
                        </a>
                      </mdb-view>
                    </mdb-col>
                    <mdb-col col="12">
                      <mdb-btn @click="openUpload('avatar')" size="sm" color="primary">Gambar Premis</mdb-btn>
                    </mdb-col>
                    <mdb-col md="3">
                      <mdb-view :src="merchant.ssm?getUrl(merchant.ssm):require('@/assets/logo.jpg')">
                        <a @click="openUrl(getUrl(merchant.ssm))">
                          <mdb-mask overlay="white-slight"></mdb-mask>
                        </a>
                      </mdb-view>
                    </mdb-col>
                    <mdb-col col="12">
                      <mdb-btn @click="openUpload('ssm')" size="sm" color="primary">Dokumen SSM</mdb-btn>
                    </mdb-col>
                  </mdb-row>
                  <mdb-row>
                    <mdb-col md="3">
                      <mdb-view :src="merchant.ic_front?getUrl(merchant.ic_front):require('@/assets/logo.jpg')">
                        <a @click="openUrl(getUrl(merchant.ic_front))">
                          <mdb-mask overlay="white-slight"></mdb-mask>
                        </a>
                      </mdb-view>
                    </mdb-col>
                    <mdb-col col="12">
                      <mdb-btn @click="openUpload('ic_front')" size="sm" color="primary">Gambar IC Depan</mdb-btn>
                    </mdb-col>
                    <mdb-col md="3">
                      <mdb-view :src="merchant.ic_back?getUrl(merchant.ic_back):require('@/assets/logo.jpg')">
                        <a @click="openUrl(getUrl(merchant.ic_back))">
                          <mdb-mask overlay="white-slight"></mdb-mask>
                        </a>
                      </mdb-view>
                    </mdb-col>
                    <mdb-col col="12">
                      <mdb-btn @click="openUpload('ic_back')" size="sm" color="primary">Gambar IC Belakang</mdb-btn>
                    </mdb-col>
                  </mdb-row>
                  <mdb-row>
                    <mdb-col md="3">
                      <mdb-view :src="merchant.logo?getUrl(merchant.logo):require('@/assets/logo.jpg')">
                        <a @click="openUrl(getUrl(merchant.logo))">
                          <mdb-mask overlay="white-slight"></mdb-mask>
                        </a>
                      </mdb-view>
                    </mdb-col>
                    <mdb-col col="12">
                      <mdb-btn @click="openUpload('logo')" size="sm" color="primary">Gambar Logo</mdb-btn>
                    </mdb-col>
                  </mdb-row>
                  <mdb-row>
                    <mdb-col md="3" v-if="merchant.menu.length==0">
                      <mdb-view :src="require('@/assets/logo.jpg')">
                        <a>
                          <mdb-mask overlay="white-slight"></mdb-mask>
                        </a>
                      </mdb-view>
                    </mdb-col>
                    <mdb-col md="3" v-for="(menu, index) in merchant.menu" v-bind:key="menu">
                      <mdb-view :src="getUrl(menu)">
                        <a @click="openUrl(getUrl(merchant.menu))">
                          <mdb-mask overlay="white-slight"></mdb-mask>
                        </a>
                      </mdb-view>
                      <mdb-btn @click="deleteMedia(index)" size="sm" style="position: absolute; top: 0; right: 0;" color="danger">x</mdb-btn>
                    </mdb-col>
                    <mdb-col col="12">
                      <mdb-btn @click="openUpload('menu')" size="sm" color="primary">Dokumen Menu ( Muat Naik satu demi satu)</mdb-btn>
                    </mdb-col>
                  </mdb-row>
                  <input type="file" id="file-upload" @change="uploadImage" hidden />
                </mdb-card-body>
            </mdb-card>
        </mdb-col>
      </mdb-row>
      <mdb-row class="mb-3">
        <mdb-col>
          <mdb-card>
            <mdb-card-body>
              <h4 class="h4-responsive" :style="{color: getColor('APP_1')}">Contact Us</h4>
              <mdb-row>
                <mdb-col col="12">
                  <mdb-input v-model.trim="merchant.remarks" label="Remarks/Nota. e.g. Waktu Operasi, lokasi GPS , dan lain-lain" size="sm" />
                </mdb-col>
              </mdb-row>
              <mdb-row>
                <mdb-col col="12">
                  <a href="https://wa.me/60163399951" target="_blank"><mdb-icon fab icon="whatsapp" /> Whatsapp (60163399951)</a>
                  <a class="ml-3" href="mailto:merchant@lapar.my" target="_blank"><mdb-icon far icon="envelope" /> Emel (merchant@lapar.my)</a>
                </mdb-col>
              </mdb-row>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col col="12">
          <mdb-btn @click="submitMerchant()" color="primary">Hantar</mdb-btn>
        </mdb-col>
      </mdb-row>
    </mdb-container>
    <Loading :visible="loading" />
    <Success :visible="success" />
  </mdb-container>
</template>

<script>

import { mdbContainer, mdbRow, mdbCol, mdbCard, mdbCardBody, mdbInput, mdbBtn, mdbView, mdbMask, mdbIcon } from 'mdbvue';
import {getColor} from '../js/colors';
import Loading from '../components/Loading';
import {fileUploadAjax, ajax} from '../js/ajax';
import {APP_FILE_URL} from '../js/config';
import {validateRequired, validateEmail, validatePhone} from '../js/validation';
import Success from '../components/Success';

export default {
  name: 'home',
  components: {
    mdbContainer, mdbRow, mdbCol, mdbCard, mdbCardBody, mdbInput, mdbBtn, Loading, mdbView, mdbMask,
    Success, mdbIcon
  },
  data: ()=>({
    merchant: {
      avatar: "",
      name: "",
      email: "",
      address: "",
      company_registration_name: "",
      bank_name: "",
      bank_account_name: "",
      bank_account_number: "",
      contact_number: "",
      owner_name: "",
      owner_ic: "",
      pic_name: "",
      pic_ic: "",
      financial_name: "",
      financial_ic: "",
      owner_mobile: "",
      owner_email: "",
      pic_mobile: "",
      pic_email: "",
      financial_mobile: "",
      financial_email: "",
      tax_id: "",
      alt_contact_number:"",
      company_registration_id:"",
      ssm: "",
      ic_front: "",
      ic_back:"",
      menu: [],
      logo: "",
      services: [],
      referral: "",
      remarks: "",
      alt_remarks: "Ahad: \nIsnin: \nSelasa: \nRabu: \nKhamis: \nJumaat: \nSabtu: ",
    },
    validation: {
      email: "",
      address: "",
      company_registration_name: "",
      bank_name: "",
      bank_account_name: "",
      bank_account_number: "",
      contact_number: "",
      owner_name: "",
      owner_ic: "",
      pic_name: "",
      pic_ic: "",
      financial_name: "",
      financial_ic: "",
      owner_mobile: "",
      owner_email: "",
      pic_mobile: "",
      pic_email: "",
      financial_mobile: "",
      financial_email: "",
    },
    validated: false,
    loading:false,
    success: false,
    focus_upload: ""
  }),
  mounted: function(){
    const url = window.location.search;
    const urlParams = new URLSearchParams(url);
    const referral = urlParams.get('referral')
    this.merchant.referral=referral;
  },
  methods: {
    getColor(text){
      return getColor(text);
    },
    copyOwnerToPIC(){
      this.merchant.pic_name=this.merchant.owner_name;
      this.merchant.pic_mobile=this.merchant.owner_mobile;
      this.merchant.pic_ic=this.merchant.owner_ic;
      this.merchant.pic_email=this.merchant.owner_email;
    },
    copyOwnerToFinance(){
      this.merchant.financial_name=this.merchant.owner_name;
      this.merchant.financial_mobile=this.merchant.owner_mobile;
      this.merchant.financial_ic=this.merchant.owner_ic;
      this.merchant.financial_email=this.merchant.owner_email;  
    },
    submitMerchant(){
      if(this.loading){
        return false;
      }
      this.validated=true;
      let proceed=true;
      if(!validateRequired(this.merchant.name)){
        this.validation.name="Nama Restoran Atau Jenama Diperlukan";
        proceed=false;
      }else{
        this.validation.name="";
      }
      if(!validateRequired(this.merchant.email) || !validateEmail(this.merchant.email)){
        this.validation.email="Emel Diperlukan atau Format Tidak Sah";
        proceed=false;
      }else{
        this.validation.email="";
      }
      if(!validateRequired(this.merchant.contact_number) || !validatePhone(this.merchant.contact_number)){
        this.validation.contact_number="No. Telefon Diperlukan atau Format Emel Tidak Sah";
        proceed=false;
      }else{
        this.validation.contact_number="";
      }
      if(!validateRequired(this.merchant.address)){
        this.validation.address="Alamat Restoran Diperlukan";
        proceed=false;
      }else{
        this.validation.address="";
      }
      if(!validateRequired(this.merchant.company_registration_name)){
        this.validation.company_registration_name="Nama SSM atau Nama Pemilik Perniagaan Diperlukan";
        proceed=false;
      }else{
        this.validation.company_registration_name="";
      }
      if(!validateRequired(this.merchant.company_registration_id)){
        this.validation.company_registration_id="No SSM atau Permilik Perniagaan Diperlukan";
        proceed= false;
      }else{
        this.validation.company_registration_id="";
      }
      if(!validateRequired(this.merchant.bank_account_name)){
        this.validation.bank_account_name="Nama Pemegang Akaun Diperlukan";
        proceed= false;
      }else{
        this.validation.bank_account_name="";
      }
      if(!validateRequired(this.merchant.bank_name)){
        this.validation.bank_name="Nama Bank Diperlukan";
        proceed= false;
      }else{
        this.validation.bank_name="";
      }
      if(!validateRequired(this.merchant.bank_account_number)){
        this.validation.bank_account_number="No Akaun Bank Diperlukan";
        proceed= false;
      }else{
        this.validation.bank_account_number="";
      }
      if(!validateRequired(this.merchant.pic_mobile)|| !validatePhone(this.merchant.pic_mobile)){
        this.validation.pic_mobile="Person in charge No.Telefon Diperlukan atau Format Tidak Sah";
        proceed= false;
      }else{
        this.validation.pic_mobile="";
      }
      if(!validateRequired(this.merchant.financial_email) || !validateEmail(this.merchant.financial_email)){
        this.validation.financial_email="Finance Emel Diperlukan atau Format Tidak Sah";
        proceed= false;
      }else{
        this.validation.financial_email="";
      }
      if(!proceed){
        var elmnt = document.getElementById("form-start");
        elmnt.scrollIntoView();
        return false;
      }
      this.loading=true;
      ajax({
        url: "submit_merchant",
        data: this.merchant,
        success: ()=>{
          this.success=true;
        },
        isShowAlert: true,
        complete:()=>this.loading=false
      }, this);
    },
    uploadImage(event){
      if(this.loading){
        return false;
      }
      this.loading=true;
      fileUploadAjax({
        url: "upload_document",
        data: {event: event.target.files},
        complete: ()=>this.loading=false,
        success: result=>{
          switch(this.focus_upload){
            case "avatar": {
              this.merchant.avatar=result.data;
              break;
            }
            case "ssm": {
              this.merchant.ssm=result.data;
              break;
            }
            case "ic_front": {
              this.merchant.ic_front=result.data;
              break;
            }
            case "ic_back": {
              this.merchant.ic_back=result.data;
              break;
            }
            case "menu": {
              let temp=[...this.merchant.menu];
              temp.push(result.data);
              this.merchant.menu=temp;
              break;
            }
            case "logo": {
              this.merchant.logo=result.data;
              break;
            }
          }
        },
        isShowAlert: true
      }, this)
    },
    openUpload(type){
      this.focus_upload=type;
      document.getElementById("file-upload").click();
    },
    getUrl(url){
      if(url){
        return APP_FILE_URL+url;
      }
      return;
    },
    openUrl(url){
      if(url){
        window.open(url);
      }
      return;
    },
    deleteMedia(index){
      this.merchant.menu.splice(index, 1);
    },
  }
}
</script>


<style scoped>
.text-link{
  cursor: pointer;
  color: #4285F4;
  font-size: 0.9rem;
}
.text-link:hover{
  cursor: pointer;
  color: #0D47A1;
}
#body-background{
  background-image: url('../assets/bg_1.jpg');
  background-repeat: no-repeat;
  background-attachment: fixed;
}
</style>